import { IGetWebClientVersionResponse } from "../entities-generated/models/authentication/get-web-client-version-response";
import { ITokenSet } from "../entities-generated/models/authentication/token-set";
import { PublicApiClient } from "./public-api-client";
import { RefreshApiClient } from "./refresh-api-client";

class AuthenticationApiClientClass {
  public refreshApiTokens() {
    return RefreshApiClient.get<ITokenSet>('auth');
  }

  public devRefreshOversightApiTokens() {
    return PublicApiClient.get<ITokenSet>('auth/dev/oversight');
  }

  public devRefreshOversightVolunteerApiTokens() {
    return PublicApiClient.get<ITokenSet>('auth/dev/volunteer');
  }

  public getWebClientVersion() {
    return PublicApiClient.get<IGetWebClientVersionResponse>('auth/web/version');
  }
}

export const AuthenticationApiClient = new AuthenticationApiClientClass();